export const APPLICANT_PROFILE_TAB = {
  compliance: 'compliance',
  documents: 'documents',
  emails: 'emails',
  overview: 'overview',
  updates: 'updates',
  viewings: 'viewings',
}

export const QA_NAME_APPLICANT_PROFILE_TAB_COMPLIANCE =
  'applicantProfileComplianceTab'

export const QA_NAME_APPLICANT_PROFILE_TAB_DOCUMENTS =
  'applicantProfileDocumentsTab'

export const QA_NAME_APPLICANT_PROFILE_TAB_EMAILS = 'applicantProfileEmailsTab'

export const QA_NAME_APPLICANT_PROFILE_TAB_OVERVIEW =
  'applicantProfileOverviewTab'

export const QA_NAME_APPLICANT_PROFILE_TAB_UPDATES =
  'applicantProfileUpdatesTab'

export const QA_NAME_APPLICANT_PROFILE_TAB_VIEWINGS =
  'applicantProfileViewingsTab'

export const QA_NAME_APPLICANT_PROFILE_TABS = 'applicantProfileTabs'

export const APPLICANT_PROFILE_TAB_LIST = [
  {
    id: APPLICANT_PROFILE_TAB.overview,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_OVERVIEW,
    titleKey: 'RentalPortal.ListingProfileTabOverviewKey',
  },
  {
    counterSection: APPLICANT_PROFILE_TAB.emails,
    id: APPLICANT_PROFILE_TAB.emails,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_EMAILS,
    titleKey: 'RentalPortal.ApplicantProfileTabEmailsKey',
  },
  {
    counterSection: APPLICANT_PROFILE_TAB.documents,
    id: APPLICANT_PROFILE_TAB.documents,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_DOCUMENTS,
    titleKey: 'RentalPortal.ListingProfileTabDocumentsKey',
  },
  {
    counterSection: APPLICANT_PROFILE_TAB.viewings,
    id: APPLICANT_PROFILE_TAB.viewings,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_VIEWINGS,
    titleKey: 'RentalPortal.ListingProfileTabViewingsKey',
  },
  {
    id: APPLICANT_PROFILE_TAB.compliance,
    isFailClosed: true,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_COMPLIANCE,
    titleKey: 'RentalPortal.ApplicantProfileTabComplianceKey',
  },
  {
    counterSection: APPLICANT_PROFILE_TAB.updates,
    id: APPLICANT_PROFILE_TAB.updates,
    qaName: QA_NAME_APPLICANT_PROFILE_TAB_UPDATES,
    titleKey: 'RentalPortal.ListingProfileTabUpdatesKey',
  },
]
